import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { ReviewMiddleware } from "../../../Store/Middlewares/ReviewMiddleware";

const PerformanceChart = ({ height, Analytics, loader }) => {
  const dispatch = useDispatch();


  console.log("Analytics", Analytics);

  const chartData = {
    series: [
      {
        name: "performance",
        data: Analytics?.data?.map((item) => item?.value),
      },
    ],
    options: {
      chart: {
        width: "100%",
        // height: 350,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      colors: ["#ED73AA"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        min: 0, // Set the minimum value for Y-axis
        max: Analytics?.max_value,
      },
      xaxis: {
        // categories: [
        //   "Jan",
        //   "Feb",
        //   "Mar",
        //   "Apr",
        //   "May",
        //   "Jun",
        //   "Jul",
        //   "Aug",
        //   "Sep",
        //   "Oct",
        //   "Nov",
        //   "Dec",
        // ],
        // labels: {
        //   format: "MMM",
        // },
        type: "datetime",
        categories: [
          "2023-01-01",
          "2023-02-01",
          "2023-03-01",
          "2023-04-01",
          "2023-05-01",
          "2023-06-01",
          "2023-07-01",
          "2023-08-01",
          "2023-09-01",
          "2023-10-01",
          "2023-11-01",
          "2023-12-01",
        ],

        labels: {
          datetimeFormatter: {
            month: "MMM", // Display abbreviated month names
          },
        },
        tickAmount: 12,
      },
      tooltip: {
        x: {
          format: "MMM",
        },
      },
    },
  };

  return (
    <div id="chart">
      {!loader && (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="area"
          // height={height ? height : 350}
          width={"100%"}
        />
      )}
    </div>
  );
};

export default PerformanceChart;
